import script from "./Head.vue?vue&type=script&setup=true&lang=js"
export * from "./Head.vue?vue&type=script&setup=true&lang=js"

import "./Head.vue?vue&type=style&index=0&id=a19b96e0&scoped=true&lang=css"
import "./Head.vue?vue&type=style&index=1&id=a19b96e0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a19b96e0"]])

export default __exports__